<!-- eslint-disable -->
<template lang="pug">
  .settings(v-if='settings')
    template(v-if="parametersFrom === 'homework'")
      template(v-if='settings.mode')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ getModeName(settings.mode) }}
        br
      template(v-if='settings.amountOfExamples && !settings.timeLimit')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
        br
      template(v-if='settings.timeLimit')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
        | {{ settings.timeLimit }}
        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
        br
      template(v-if="settings.numbers.length !== 0")
        | {{ $i18n.t('trainer.trainer_gameFormSetting_multipliers') }}: {{ settings.numbers.join(', ') }}
    slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
    };
</script>
